var TRAVEL_BRIEFCASE_BAG = {
  "default": 'M28,5H22V2.5A1.5,1.5,0,0,0,20.5,1h-9A1.5,1.5,0,0,0,10,2.5V5H4A4,4,0,0,0,0,9V27a4,4,0,0,0,4,4H28a4,4,0,0,0,4-4V9A4,4,0,0,0,28,5ZM12,3h8V5H12ZM24,7V29H8V7ZM2.59,28.41A2,2,0,0,1,2,27V9A2,2,0,0,1,4,7H6V29H4A2,2,0,0,1,2.59,28.41ZM30,27a2,2,0,0,1-2,2H26V7h2a2,2,0,0,1,2,2Z'
};

export { TRAVEL_BRIEFCASE_BAG };
//# sourceMappingURL=TRAVEL_BRIEFCASE_BAG.js.map
